// extracted by extract-css-chunks-webpack-plugin
module.exports = {"split-flap":"split-flap___Dh7jc","comma":"comma___a991J","period":"period___pJ_F7","card":"card___ESGZU"};